import { Box, type SxProps } from '@mui/material';

export const StarIcon = ({
  additionalStyles,
  color = '#64666A',
  testid,
}: {
  additionalStyles?: SxProps;
  color?: string;
  testid?: string;
}) => {
  return (
    <Box
      component="span"
      sx={{
        '--star-svg': `url("data:image/svg+xml;utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 19'><path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/></svg>")`,
        width: '15px',
        height: '15px',
        marginRight: '2px',
        marginLeft: '1px',
        overflow: 'hidden',
        WebkitMaskImage: 'var(--star-svg)',
        maskImage: 'var(--star-svg)',
        ...additionalStyles,
        background: color,
      }}
      data-testid={testid}
    />
  );
};
